<template>
	<div class="main-bg">
		<div class="main">
			<div class="content">
				<div class="left">
					<div class="lrc font-4">
						<div class="lrc-p">
							<p v-for="item , key in lrc" :key="key" :class="lrc_index == key ? 'red' : ''">{{item.content}}</p>
						</div>
					</div>
					<div class="audio">
						<img src="../img/ic17.png" class="img-1" v-show="isPlay" @click="pause">
						<img src="../img/ic38.png" class="img-1" v-show="!isPlay" @click="play">
						<img src="../img/ic18.png" class="img-2" @click="reset">
						<div class="progress">
							<el-slider @mousedown.native="isMove = true" @mouseup.native="isMove = false" @change="changeTime" v-model="now_time" :max="audio_time" :format-tooltip="format"></el-slider>
						</div>
						<font>{{format(now_time)}} / {{format(audio_time)}}</font>
						<img src="../img/ic22.png" class="img-3" v-show="isMute" @click="isMute = !isMute">
						<img src="../img/ic21.png" class="img-3" v-show="!isMute" @click="isMute = !isMute">
					</div>
				</div>
				<div class="right">
					<img src="../img/ic34.png" />
					<div class="info font-4">
						<p v-html="'作&emsp;词：朱水涌'"></p>
						<p v-html="'作&emsp;曲：谷建芬'"></p>
						<p v-html="'配&emsp;器：张宏光'"></p>
					</div>
					<div class="an" @click="about(6)">
						<div v-html="'花&emsp;絮'"></div>
					</div>
					<div class="an">
						<div v-html="'音&emsp;乐'"></div>
					</div>
				</div>
			</div>
			<jm-nav></jm-nav>
		</div>
		<img src="../img/ic10.png" class="body-bg" />
		<audio preload src="../media/相聚在美丽的校园 合唱.mp3"></audio>
	</div>
</template>
<script>
import jmNav from '../components/jm_nav.vue'
import $ from "jquery";
export default {
	data() {
		return {
			audio:'',
			isMove:false,
			isPlay:false,
			isMute:false,
			audio_time:0,
			now_time:0,
			lrc_index:-1,
			lrc:[{
				time:20.23,
				content:'我们相聚在美丽的校园'
			},{
				time:24.19,
				content:'心中装满百年的眷念'
			},{
				time:30.92,
				content:'回想入学相识的那一天'
			},{
				time:35.2,
				content:'碧海蓝天 凤凰花艳'
			},{
				time:41.6,
				content:'面朝深情的大海'
			},{
				time:45.94,
				content:'我们铺开青春的跑道'
			},{
				time:50.33,
				content:'我们感怀厦大'
			},{
				time:54.81,
				content:'生命的“知无央 爱无疆”'
			},{
				time:78.49,
				content:'我们重逢在久别的校园'
			},{
				time:83.21,
				content:'心中泛起青春的思念'
			},{
				time:89.81,
				content:'回想毕业别离的那一天'
			},{
				time:94.17,
				content:'海天万里 白鹭翱翔'
			},{
				time:100.82,
				content:'告别校园的那一天'
			},{
				time:105.07,
				content:'我们背起报效的行囊'
			},{
				time:109.5,
				content:'我们感怀厦大'
			},{
				time:113.73,
				content:'生命的“知无央 爱无疆”'
			},{
				time:120.58,
				content:'生命的坚守至善自强'
			},{
				time:131.74,
				content:'自强'
			}]
		}
	},
	mounted() {
		this.audio = document.getElementsByTagName("audio")[0];
		this.audio.oncanplay = () => {  
			if(!this.audio_time){
				this.audio_time = this.audio.duration
				this.play()
			}
		}
		this.audio.addEventListener("timeupdate",() => {
			if(!this.isMove)
				this.now_time = this.audio.currentTime
		})
	},
	methods: {
		play(){
			this.audio.play()
			this.isPlay = true
		},
		pause(){
			this.audio.pause()
			this.isPlay = false
		},
		reset(){
			this.audio.currentTime = 0
			this.pause()
		},
		changeTime(val){
			this.audio.currentTime = parseInt(val)
		},
		format(time){
			let i = parseInt(time / 60)
			let s = parseInt(time % 60)
			if(i < 10)
				i = "0" + i;
			if(s < 10)
				s = "0" + s;
			return i + ':' + s
		},
		about(index){
			this.$router.push({ path:'/About/' + index + '.html'});
		}	
	},
	watch:{
		isMute(val){
			this.audio.muted = val
		},
		now_time(val){
			for(let i = this.lrc.length - 1 ; i >= 0 ; i--){
				var item = this.lrc[i]
				if(val > item.time){
					this.lrc_index = i
					break;
				}
			}
		},
		lrc_index(val){
			$(".lrc-p").stop(true,true).animate({top:'-' + (val * 1.7) + 'rem'});
		},
	},
	components:{
		jmNav
	}
}
</script>
<style scoped>
.main{
	background: rgba(255,255,255,.3);
	width: 70rem;
	margin: 0 auto;
	border-radius: .5rem;
	padding-bottom: 2rem;
	z-index: 2;
	position: fixed;
	left: 50%;
	margin-left: -35rem;
	top: 50%;
	transform: translateY(-50%);
}
.main .content{
	padding-top: 2rem;
	display: flex;
	background: url(../img/ic35.png) no-repeat left center;
	background-size: 25rem;
	justify-content: flex-end;
	align-items: center;
	height: 31rem;
}
.main .right{
	margin-right: 4rem;
	align-items: center;
	display: flex;
	flex-direction: column;
}
.main .right img{
	display: flex;
	width: 6.5rem;
	position: relative;
	left: -.725rem;
}
.main .info{
	width: 6.5rem;
	margin: .75rem 0;
}
.main .info p{
	font-size: .9rem;
	color:#000;
	display: flex;
	height: 1.2rem;
	align-items: center;
	justify-content: center;
}
.body-bg{
	position: fixed;
	width: 100%;
	bottom: 0;
	left: 0;
}
.left{
	width: 45rem;
}
.lrc-p{
	position: relative;
}
.lrc{
	height: 27.1rem;
	overflow: hidden;
}
.lrc p{
	font-size: 1.1rem;
	color: #92443c;
	height: 1.7rem;
	display: flex;
	align-items: center;
	justify-content: center;
}
.audio{
	display: flex;
	align-items: center;
	justify-content: center;
}
.audio font{
	color: #d7412a;
	font-weight: bold;
	margin-left: .5rem;
}
.img-1{
	display: flex;
	width: 1rem;
	height: 1rem;
	margin-right: .5rem;
	cursor: pointer;
}
.img-2{
	display: flex;
	width: 1rem;
	height: 1rem;
	margin-right: 1rem;
	cursor: pointer;
}
.img-3{
	display: flex;
	width: 1.35rem;
	height: 1rem;
	margin-left: .5rem;
	cursor: pointer;
}
.progress{
	width: 15rem;
}
.an{
	border-radius: .25rem;
	color: #cbb080;
	background-color: #d7412a;
	width: 5rem;
	height: 2rem;
	padding: .15rem;
	margin-bottom: .5rem;
	cursor: pointer;
}
.an div{
	border-radius: .25rem;
	border:1px solid #cbb080;
	height: 100%;
	display: flex;
	align-items: center;
	font-family: '宋体';
	justify-content: center;
	font-weight: bold;
	font-size: 1rem;
}
.lrc-p .red{
	color: #d7412a;
	font-weight: bold;
}
</style>